import { CSSProperties } from "react";
import { makeStyles } from "tss-react/mui";

import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from "@mui/material";

const useStyles = makeStyles()(() => ({
    childrenBox: {
        display: "inline-block",
    },
}));

export type TooltipProps = Omit<MuiTooltipProps, "arrow" | "title"> & {
    hide?: boolean;
    title?: MuiTooltipProps["title"];
    childrenBoxStyles?: CSSProperties;
    disableChildrenWrapper?: boolean;
};

export const Tooltip = ({
    children,
    hide = false,
    title = "",
    childrenBoxStyles = {},
    disableChildrenWrapper = false,
    ...rest
}: TooltipProps) => {
    const { classes } = useStyles();

    if (hide) {
        return children;
    }

    return (
        <MuiTooltip
            arrow
            placement="top"
            title={title}
            disableInteractive
            enterDelay={200}
            enterNextDelay={100}
            enterTouchDelay={50}
            slotProps={{
                popper: {
                    popperOptions: {
                        strategy: "fixed",
                    },
                    modifiers: [
                        {
                            name: "preventOverflow",
                            enabled: true,
                            options: {
                                altAxis: true,
                                padding: 8,
                                boundary: "viewport",
                            },
                        },
                        {
                            name: "flip",
                            enabled: true,
                            options: {
                                padding: 8,
                            },
                        },
                    ],
                },
            }}
            {...rest}
        >
            {disableChildrenWrapper ? (
                children
            ) : (
                // Do not fold childrenBoxStyles into a parameterised useStyles class: tss-react memoizes
                // by a structural key only when every param is a string/number/boolean/null/undefined
                // (getDependencyArrayRef), and falls back to reference equality once a param is itself
                // an object. childrenBoxStyles is an object, so every one of the ~180 Tooltips in the app
                // would re-serialize its styles through emotion on every render.
                // eslint-disable-next-line react/forbid-dom-props -- see above
                <div className={classes.childrenBox} style={childrenBoxStyles}>
                    {children}
                </div>
            )}
        </MuiTooltip>
    );
};
